import Client from './Clients/ScrapingToolsClient'

const getTokenResource = '/auth/api/token/'
const refreshTokenResource = '/auth/api/token/refresh/'

export default {
    login(username,password){
        return Client.post(getTokenResource,{'username':username,'password':password});
    },
    refresh(refreshToken){
        return Client.post(refreshTokenResource,{'refresh':refreshToken});
    }
}
